(function($) {
	
	$(function() {
	
		var $block = $('.wp-block-metropolis-carousel-navigation');
		
		$block.each( function() {
			
			const $this = $(this);
			const carousel_id = $this.data('carousel-id');
			let swiper;
			
			const loading = setInterval(function() {
				swiper = document.getElementById(carousel_id).swiper;
				if( swiper ) {
					clearInterval(loading);
				}
			}, 100);
			
			const $prev = $this.children('.swiper-button-prev');
			const $next = $this.children('.swiper-button-next');
						
			$prev.on('click', function() {
				swiper.slidePrev();
			});
			
			$next.on('click', function() {
				swiper.slideNext();
			});
		
		});
		
	});
	
})(jQuery);